import React from 'react'
import Center from './Center'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import { StyleSheet, css } from 'aphrodite';
import { FacebookFilled } from '@ant-design/icons';
import { Typography } from 'antd';

let styles = StyleSheet.create({
    background: {
        background: '#85203b',
        textAlign: 'center',
        padding: '7% 0 7% 0%',
        color: 'white'
    },
    h2: {
        // fontSize: 'min(36px,3vw)',
        color: '#fff',
        filter: 'brightness(100%) !important'

    },
    btn: {
        fontSize: 'min(10vw,70px)',
        color: '#fff',
    }
})
const Intro5 = () => {
    return (
        <div className={css(styles.background)}>
            <Center>
                <Typography.Title className={css(styles.h2)}>
                    We <FontAwesomeIcon icon={faHeart} style={{ color: 'red' }} /> new friends!
                    </Typography.Title>
                <a className={css(styles.btn)} href="https://www.facebook.com/meetain.io"><FacebookFilled style={{ color: '#3b5998' }} /></a>
            </Center>
        </div>

    )
}

export default Intro5
